export default {
	title: 'Imagen del Dispositivo',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione los registros a eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		imageFormatError: '¡Solo se permiten imágenes en formato JPG/PNG!',
		imageSizeError: '¡El tamaño de la imagen no puede exceder 10MB!',
		uploadSuccess: 'Imagen cargada exitosamente',
		uploadError: 'Error al cargar la imagen',
		addSensorSuccess: 'Exitosamente añadido {count} sensores',
		updateSensorSuccess: 'Exitosamente actualizado {count} sensores',
		noValidSensor: 'Por favor complete al menos una información completa del sensor',
		duplicateSensorName: 'Los siguientes nombres de sensor ya existen: {names}'
	},
	form: {
		deviceTypeId: 'Tipo de Dispositivo',
		placeholder: {
			deviceTypeId: 'Por favor seleccione el tipo de dispositivo'
		}
	},
	table: {
		id: 'ID',
		name: 'Nombre de la Solución',
		deviceTypeId: 'Tipo de Dispositivo',
		sensorNumber: 'Cantidad de Sensores',
		filePath: 'Imagen del Dispositivo'
	},
	widgetForm: {
		deviceTypeId: 'Tipo de Dispositivo',
		deviceImage: 'Imagen del Dispositivo',
		gridLayout: 'Diseño de Cuadrícula',
		placeholder: {
			deviceTypeId: 'Por favor seleccione el tipo de dispositivo'
		}
	},
	dialog: {
		add: 'Añadir',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		batchAddSensor: 'Añadir Sensores en Lote'
	},
	labels: {
		solutionName: 'Nombre de la Solución',
		deviceType: 'Tipo de Dispositivo',
		deviceImage: 'Imagen del Dispositivo',
		isDefault: 'Es Predeterminado',
		yes: 'Sí',
		no: 'No',
		sensorName: 'Nombre del Sensor',
		partName: 'Nombre de la Parte',
		serialNumber: 'Número de Serie',
		addSensor: 'Añadir Sensor',
		addSensorRow: 'Añadir Fila de Sensor',
		operation: 'Operación'
	}
}
